import { http } from '../../config/axios'

export default function ativarCampanha(id: string): Promise<string> {
  return http
    .patch('api/campanha/ativar/' + encodeURIComponent(id))
    .then((res) => res.data as string)
    .catch((error) => {
      console.error('Erro ativar campanha', error)
      throw Error(error.response.data)
    })
}
